"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultSelectedPayCodeATPlus = exports.getDefaultPayCodeSummaryFromSelectedDate = exports.ATPlusSelfClassificationModalContent = void 0;
const react_1 = __importStar(require("react"));
const SelfClassification_1 = require("../../../../components/HourlyBreakdown/SelfClassification");
const Modal_1 = require("@amzn/atoz-web/Modal");
const luxon_1 = require("luxon");
const Button_1 = require("@amzn/atoz-web/Button");
const Col_1 = require("@amzn/atoz-web/Col");
const Text_1 = require("@amzn/atoz-web/Text");
const utils_1 = require("../../../../utils");
const contexts_1 = require("../../../../contexts");
const logger_1 = require("../../../../logger");
const ATPlusSelfClassificationModalContent = (props) => {
    const { payCodeToClassify, payCodeSummary, payCodesInfo, selectedDate, close } = props;
    const isUpdateSelfClassification = !!payCodeToClassify;
    const defaultPayCodeList = isUpdateSelfClassification
        ? getATPlusSelfClassifiedPayDataList(payCodeSummary, payCodeToClassify, props.timeZone)
        : [
            (0, exports.getDefaultPayCodeSummaryFromSelectedDate)(selectedDate, payCodesInfo, payCodeToClassify)
        ];
    const { clientName } = (0, contexts_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    logger_1.logger.emitCountMetric({
        metricName: isUpdateSelfClassification
            ? logger_1.METRICS.ATPLUS_SELF_CLASSIFICATION_EDIT_BUTTON_CLICK.COUNT
            : logger_1.METRICS.ATPLUS_SELF_CLASSIFICATION_ADD_BUTTON_CLICK.COUNT,
        dimensions
    });
    const [payCodeList, setPayCodeList] = (0, react_1.useState)(defaultPayCodeList);
    (0, react_1.useEffect)(() => {
        setPayCodeList(defaultPayCodeList);
    }, [JSON.stringify(defaultPayCodeList)]);
    const totalHoursString = (0, react_1.useMemo)(() => (0, SelfClassification_1.getTotalHoursStringATPlus)(payCodeList), [payCodeList]);
    const isSubmitButtonDisabled = totalHoursString === SelfClassification_1.INVALID_TOTAL_HOURS_STRING;
    const resetModalContent = () => {
        setPayCodeList(defaultPayCodeList);
    };
    return (react_1.default.createElement(Modal_1.ModalContent, { titleText: props.selectedDate.toLocaleString(luxon_1.DateTime.DATE_FULL), dataTestId: SelfClassification_1.MODAL_TEST_ID, buttons: [
            react_1.default.createElement(SelfClassification_1.SubmitATPlusSelfClassificationButton, { key: "submitSelfClassification", isSubmitButtonDisabled: isSubmitButtonDisabled, addPayCodeRequest: buildAddPayCodeRequest(props, payCodeList), editPayCodeRequest: buildEditPayCodeRequest(props, payCodeList), useEditPayCodeResponse: props.useEditPayCodeResponse, useAddPayCodeResponse: props.useAddPayCodeResponse, isUpdateSelfClassification: isUpdateSelfClassification, selectedDate: props.selectedDate, timezone: props.timeZone }),
            react_1.default.createElement(Button_1.Button, { dataTestId: SelfClassification_1.CANCEL_BUTTON_TEST_ID, key: "cancel", onClick: () => {
                    resetModalContent();
                    close();
                } }, "Cancel")
        ], onCloseButtonClick: () => {
            resetModalContent();
            close();
        } },
        react_1.default.createElement(Col_1.Col, { gridGap: "S300" },
            react_1.default.createElement(SelfClassification_1.PayPeriodRedirect, null),
            react_1.default.createElement(SelfClassification_1.PunchesOverview, { selectedDate: props.selectedDate, punchesTimeSegments: props.punchesTimeSegments }),
            isUpdateSelfClassification && (react_1.default.createElement(SelfClassification_1.PayCodeSelection, { payCodesInfo: props.payCodesInfo, selectedPayCode: (0, exports.getDefaultSelectedPayCodeATPlus)(props.payCodesInfo, props.payCodeToClassify), isWECoreSelfClassification: props.isWECoreSelfClassification, setPayCodeList: setPayCodeList, payDataIndex: 0, isDisabled: true })),
            react_1.default.createElement(SelfClassification_1.TimeManagementSection, { payCodeList: payCodeList, setPayCodeList: setPayCodeList, totalHoursString: totalHoursString, selectedDate: props.selectedDate, payCodePolicyInfo: props.payCodePolicyInfo, payCodesInfo: props.payCodesInfo, payCodeToClassify: props.payCodeToClassify, isWECoreSelfClassification: props.isWECoreSelfClassification, isUpdateSelfClassification: isUpdateSelfClassification }),
            react_1.default.createElement(Text_1.Text, { fontSize: "T100", color: "neutral80" }, "Please note that it may take up to an hour for any changes to appear on this page after a submission is made. Submissions of hours worked are validated against Amazon Security systems for accuracy. Reporting false information may result in disciplinary action up to and including termination"))));
};
exports.ATPlusSelfClassificationModalContent = ATPlusSelfClassificationModalContent;
const getDefaultPayCodeSummaryFromSelectedDate = (selectedDate, payCodesInfo, payCodeToClassify) => {
    const defaultSelectedPayCode = (0, exports.getDefaultSelectedPayCodeATPlus)(payCodesInfo, payCodeToClassify);
    return {
        payCodeName: defaultSelectedPayCode,
        startDateTime: selectedDate.toISODate(),
        endDateTime: selectedDate.toISODate()
    };
};
exports.getDefaultPayCodeSummaryFromSelectedDate = getDefaultPayCodeSummaryFromSelectedDate;
const getDefaultSelectedPayCodeATPlus = (payCodesInfo, payCodeToClassify) => {
    return payCodeToClassify !== null && payCodeToClassify !== void 0 ? payCodeToClassify : payCodesInfo.payCodes[0].description;
};
exports.getDefaultSelectedPayCodeATPlus = getDefaultSelectedPayCodeATPlus;
const getATPlusSelfClassifiedPayDataList = (payCodeSummaryByDate, payCodeClassified, timezone) => {
    return payCodeSummaryByDate.payCodeSummary
        .filter((payCode) => payCode.payCodeName == payCodeClassified)
        .map((payCode) => {
        return Object.assign(Object.assign({}, payCode), { startDateTime: (0, utils_1.getSelfClassificationDateTimeString)(payCode.startDateTime, timezone), endDateTime: (0, utils_1.getSelfClassificationDateTimeString)(payCode.endDateTime, timezone) });
    });
};
const buildEditPayCodeRequest = (props, payCodeListToBeAdded) => {
    const payCodeTobeEdited = getExistingPayCodeItem(props);
    if (payCodeTobeEdited === undefined)
        return undefined;
    const existingPayCode = {
        employeeId: props.employeeId,
        payCodeInputBody: {
            startDateTime: (0, utils_1.trimISOStringSeconds)(luxon_1.DateTime.fromISO(payCodeTobeEdited.startDateTime)),
            duration: (0, utils_1.getHoursDifference)(payCodeTobeEdited.startDateTime, payCodeTobeEdited.endDateTime),
            payCodeName: payCodeTobeEdited.payCodeName,
            notes: ''
        }
    };
    const payloadForEditPayCodeRequest = payCodeListToBeAdded.map(({ startDateTime, endDateTime, payCodeName }) => {
        const startDateTimeUTC = (0, utils_1.getUpdatePayDataRequestDateTimeString)(startDateTime, props.timeZone);
        const endDateTimeUTC = (0, utils_1.getUpdatePayDataRequestDateTimeString)(endDateTime, props.timeZone);
        return {
            existingPayCodeBody: existingPayCode,
            updatedPayCodeBody: {
                employeeId: props.employeeId,
                payCodeInputBody: {
                    startDateTime: (0, utils_1.trimISOStringSeconds)(luxon_1.DateTime.fromISO(startDateTimeUTC)),
                    duration: (0, utils_1.getHoursDifference)(startDateTimeUTC, endDateTimeUTC),
                    payCodeName,
                    notes: ''
                }
            }
        };
    });
    return { updatePayCodeBody: payloadForEditPayCodeRequest };
};
const getExistingPayCodeItem = ({ payCodeSummary, payCodeToClassify }) => {
    return payCodeSummary.payCodeSummary.find((payCodeSummary) => payCodeSummary.payCodeName === payCodeToClassify);
};
const buildAddPayCodeRequest = (props, payCodeListToBeAdded) => {
    const payDataForUpdatePayDataRequest = payCodeListToBeAdded.map(({ payCodeName, startDateTime, endDateTime }) => {
        const startDateTimeUTC = (0, utils_1.getUpdatePayDataRequestDateTimeString)(startDateTime, props.timeZone);
        const endDateTimeUTC = (0, utils_1.getUpdatePayDataRequestDateTimeString)(endDateTime, props.timeZone);
        return {
            startDateTime: (0, utils_1.trimISOStringSeconds)(luxon_1.DateTime.fromISO(startDateTimeUTC)),
            duration: (0, utils_1.getHoursDifference)(startDateTimeUTC, endDateTimeUTC),
            payCodeName: payCodeName,
            notes: '',
            deleteItems: false,
            partialScheduleOverride: false
        };
    });
    return {
        payCodeInputBody: payDataForUpdatePayDataRequest
    };
};
